export const SITE_URL = "https://www.growthrail.dev";
export const DOCS_URL = "https://docs.growthrail.dev";
export const APP_URL = "https://app.growthrail.dev";
export const API_URL = "https://api.growthrail.dev";

export const SITE_NAME = "GrowthRail";
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;
export const LOGO_URL = `${SITE_URL}/logo.svg`;

export function absoluteUrl(path = "/") {
  return new URL(path, SITE_URL).toString();
}
